import Axios from "axios";

const API_URL = process.env.REACT_APP_ENV == 'dev' ? process.env.REACT_APP_API_URL : `${location.origin}/api`;
Axios.defaults.baseURL = API_URL;

export class HttpService {
  _axios = Axios.create();

  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.response.use(onFulfilled, onRejected);
  };


  get = async (url, options = {}) =>
    await this.request(this.getOptionsConfig("get", url, null, options));

  post = async (url, data, options = {}) =>
    await this.request(this.getOptionsConfig("post", url, data, options));

  put = async (url, data, options = {}) =>
    await this.request(this.getOptionsConfig("put", url, data, options));

  patch = async (url, data, options = {}) =>
    await this.request(this.getOptionsConfig("patch", url, data, options));

  delete = async (url, data, options = {}) =>
    await this.request(this.getOptionsConfig("delete", url, data, options));

  getOptionsConfig = (method, url, data, options = {}) => {
    // Retrieve session token from sessionStorage if available
    const sessionToken = sessionStorage.getItem("onboarding_session_token");

    return {
      method,
      url,
      data,
      headers: {
        "Content-Type": "application/vnd.api+json",
        "x-onboarding-session-token": sessionToken || "",
        ...(options.headers || {}),
      },
      signal: options?.signal, // 👈 pass signal if present
      ...options,
    };
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then((res) => resolve(res.data))
        .catch((ex) => {
          // if abort, bubble up native error (not ex.response)
          if (ex.name === "CanceledError" || ex.name === "AbortError") {
            reject(ex);
          } else {
            reject(ex.response?.data || ex);
          }
        });
    });
  }
}

export default new HttpService();
